document.addEventListener("DOMContentLoaded", function () {
  const ingredientsPopupDialog = document.getElementById("ingredients-popup");
  const ingredientsPopupButton = document.getElementById(
    "ingredients-popup-button"
  );

  // Check if the button exists
  if (ingredientsPopupButton) {
    // Show popup when the button is clicked
    ingredientsPopupButton.addEventListener("click", function () {
      ingredientsPopupDialog.showModal();
    });

    // Hide popup when clicking outside of it
    ingredientsPopupDialog.addEventListener("click", function (e) {
      // Check if the click occurred outside of the popup
      if (e.target === ingredientsPopupDialog) {
        ingredientsPopupDialog.close();
      }
    });
  }
});
